import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql, compose } from "react-apollo";
import { queryGetCustomerFromCase, mutationAddFieldToCustomer } from "Apollo";
import Picker from "./PickerFieldWithQuery";
import FieldRow from "./FieldRowWithMutation";
import Button from "module-common/Button";
import { ShowNotice } from "Store";

export default compose(
  graphql(queryGetCustomerFromCase),
  graphql(mutationAddFieldToCustomer)
)(
  class CustomerField extends Component {
    static propTypes = {
      customerName: PropTypes.string,
      editable: PropTypes.bool
    };

    render() {
      const {
        data: { refetch, getCustomerFromCase },
        customerName,
        editable
      } = this.props;
      const fields = [];
      fields.push(
        <FieldRow key="name" name="Name" value={customerName} disabled />
      );

      const customer = getCustomerFromCase;
      if (customer && customer.fields) {
        customer.fields.forEach(field =>
          fields.push(
            <FieldRow
              key={field.id}
              customerId={customer.id}
              fieldId={field.id}
              name={field.fieldType.displayName}
              value={field.value}
              refetch={refetch}
              disabled={!editable}
            />
          )
        );
      }

      const addNewFieldButton = editable && (
        <Picker onSelected={this.onSelected}>
          <Button size="medium" color="green">
            + Add new field
          </Button>
        </Picker>
      );

      return (
        <Wrapper>
          {fields}
          {addNewFieldButton}
        </Wrapper>
      );
    }

    onSelected = async selected => {
      const { mutate, data: { getCustomerFromCase, refetch } } = this.props;
      const customer = getCustomerFromCase;
      if (!customer) return;

      try {
        await mutate({
          variables: {
            customerInput: { id: customer.id },
            customerFieldTypeInput: { id: selected.value.id },
            content: ""
          }
        });
        refetch();
      } catch (error) {
        ShowNotice("customer-field-add-error");
      }
    };
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 12px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/customer-field/CustomerFieldWithQueryMutation.js